module.exports = __webpack_public_path__ + "media/img/auth/leader-fb735b3aa41d1fa5d03c3f80159d8625.jpg";